import { SlideWaveBackground } from "@/components/investors/slides/SlideWaveBackground";

export function IntroCTASlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="relative flex flex-col justify-center h-full">
      <SlideWaveBackground />
      <div className="relative z-10 flex gap-12">
        {/* Left — CTA content */}
        <div className="flex-1">
          <h2 className="text-[32px] font-light tracking-tight leading-snug font-[family-name:var(--font-heading)] mb-4 max-w-[520px]">
            See how COSX can support your business.
          </h2>
          <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light max-w-[440px] mb-8">
            We&apos;ll walk through how AI agents can integrate into your existing workflows, with compliance and professional oversight built in from day one.
          </p>

          {/* What happens next */}
          <div>
            <p className="text-[10px] font-[family-name:var(--font-mono)] tracking-widest uppercase text-[var(--color-fg-tertiary)] mb-3">
              What happens next
            </p>
            <ol className="space-y-2">
              {[
                "A short call to understand your business and compliance requirements",
                "We identify where AI agents can support your existing workflows",
                "A tailored walkthrough using your industry as the example",
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="text-[11px] font-[family-name:var(--font-mono)] text-[var(--color-accent)] font-medium mt-px">{i + 1}.</span>
                  <span className="text-[13px] text-[var(--color-fg-secondary)] leading-snug">{item}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>

        {/* Right — Contact */}
        <div className="w-[30%] shrink-0 flex flex-col justify-center">
          <div className="border-l border-[var(--color-border)] pl-8">
            <p className="text-[16px] font-medium font-[family-name:var(--font-heading)] mb-1">Ben Zhang</p>
            <a href="mailto:ben@cosx.co" className="text-[13px] font-[family-name:var(--font-mono)] text-[var(--color-accent)] hover:opacity-80 transition-opacity block mb-1">ben@cosx.co</a>
            <a href="https://cosx.co" target="_blank" rel="noopener noreferrer" className="text-[13px] font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] transition-colors block mb-3">cosx.co</a>
            <p className="text-[9px] font-[family-name:var(--font-mono)] tracking-widest uppercase text-[var(--color-fg-tertiary)]">
              London · Sydney · Singapore
            </p>
          </div>

          <div className="border-l border-[var(--color-border)] pl-8 mt-6">
            <p className="text-[10px] text-[var(--color-fg-tertiary)] font-[family-name:var(--font-mono)] italic leading-relaxed">
              Ask us for our AI Paralegal Agents deck for a detailed look at how the platform works in legal workflows.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
